var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Icon, Stack, useTheme } from "@fluentui/react";
import React, { useId } from "react";
import { getResources } from "../../../getResources";
import { getDisplayFlex } from "../EvolvedSettingsDialog.styles";
import EvolvedSettingsAction from "./EvolvedSettingsAction";
import { getActionIconStackStyle, getActionIconStyle, } from "./EvolvedSettingsAction.styles";
// An object that performs some action while providing text and optionally two icons which is treated as a button by the UX.
const EvolvedSettingsButton = React.memo((_a) => {
    var { title, actionIconName, callback, isMultiLine } = _a, rest = __rest(_a, ["title", "actionIconName", "callback", "isMultiLine"]);
    const theme = useTheme();
    const id = "action-setting-button-" + useId();
    return React.createElement(EvolvedSettingsAction, Object.assign({ id: id, title: title, onClick: callback, actionNode: React.createElement(Stack.Item, { styles: getDisplayFlex(getActionIconStackStyle(isMultiLine)), "aria-label": title + " " + getResources().SettingsEvolvedDialog_Shared_OpenText },
            React.createElement(Icon, { iconName: actionIconName, styles: getDisplayFlex(getActionIconStyle(theme)) })), isMultiLine: isMultiLine }, rest));
});
export default EvolvedSettingsButton;
